var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isFetchingEmployees
      ? _c(
          "section",
          [
            _c("spinner-loader", {
              attrs: { loading: _vm.isFetchingEmployees },
            }),
          ],
          1
        )
      : _vm.errored
      ? _c("section", [
          _c("p", { staticClass: "centerscreen" }, [
            _vm._v("An error occurred."),
          ]),
        ])
      : _c("section", [
          _c(
            "div",
            [
              _vm.employees.length < 1
                ? _c("section", [
                    _c("p", [_vm._v("There are currently no employees.")]),
                  ])
                : _c(
                    "section",
                    [
                      _c(
                        "b-row",
                        {
                          staticClass: "search-header",
                          attrs: { "align-h": "center" },
                        },
                        [
                          _c(
                            "b-col",
                            { staticClass: "my-1", attrs: { md: "6" } },
                            [
                              _c(
                                "b-input-group",
                                [
                                  _c("b-form-input", {
                                    attrs: { placeholder: _vm.$t("search") },
                                    model: {
                                      value: _vm.filter,
                                      callback: function ($$v) {
                                        _vm.filter = $$v
                                      },
                                      expression: "filter",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-input-group-append",
                                    [
                                      _c(
                                        "b-btn",
                                        {
                                          attrs: { disabled: !_vm.filter },
                                          on: {
                                            click: function ($event) {
                                              _vm.filter = ""
                                            },
                                          },
                                        },
                                        [_vm._v("  X  ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-table", {
                        ref: "EmployeeTable",
                        staticClass: "employee-table",
                        attrs: {
                          stacked: "xs",
                          hover: "",
                          filter: _vm.filter,
                          emptyFilteredText: _vm.emptyFilteredText,
                          items: _vm.employees,
                          fields: _vm.fields,
                          striped: "",
                          light: "",
                        },
                        on: { "row-clicked": _vm.rowClicked },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(is_active)",
                            fn: function (row) {
                              return [_vm._v(_vm._s(row.value ? "On" : "Off"))]
                            },
                          },
                          {
                            key: "cell(active)",
                            fn: function (row) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      row.item.is_active ? "ACTIVE" : "INACTIVE"
                                    ) +
                                    "\n          "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(tools)",
                            fn: function (row) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "md",
                                          variant: "outline-secondary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleUpdateEmployeeStatus(
                                              row.item.id,
                                              row.item.is_active
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                EDIT\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "row-details",
                            fn: function (row) {
                              return [
                                _c(
                                  "b-card",
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        class: {
                                          btnActive: row.item.is_active,
                                        },
                                        attrs: {
                                          size: "md",
                                          variant: "outline-secondary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleUpdateEmployeeStatus(
                                              row.item.id,
                                              row.item.is_active
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              row.item.is_active
                                                ? "ACTIVE"
                                                : "INACTIVE"
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "md",
                                          variant: "outline-secondary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleUpdateEmployeeStatus(
                                              row.item.id,
                                              row.item.is_active
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                RESET PIN\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "md",
                                          variant: "outline-secondary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleUpdateEmployeeStatus(
                                              row.item.id,
                                              row.item.is_active
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                EDIT\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
              _vm._v(" "),
              _c("employee-modal", {
                ref: "employeeModal",
                staticClass: "contact-modal-btn-new employee-modal",
                on: { updateDone: _vm.getEmployees },
              }),
            ],
            1
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }